module.exports = __webpack_public_path__ + "static/media/logoimg.a98190e9.svg";